@use "../Clickables/index.module.scss" as *;
@use "../../styles/breakpoint.module.scss" as *;

.root {
    --header-to-slides-margin: var(--spacer-40);
}

.match {
    composes: root;
    composes: match from "../../styles/theming.module.css";
}

.contrast {
    composes: root;
    composes: contrast from "../../styles/theming.module.css";
}

.header {
    composes: container from "../../styles/composable/layout.module.css";
    margin-bottom: var(--header-to-slides-margin);

    @media ($above-mobile) {
        padding-right: var(--spacer-120);
    }
}

.inner {
    position: relative;

    @media ($below-mobile) {
        margin-inline: var(--labui-container-margin);
    }
}

.mediaWrapper {
    position: relative;
    display: inline-block;
    width: 57%;
    height: auto;
    aspect-ratio: 2;
    overflow: hidden;
    vertical-align: top;

    & :is(img, video) {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

    @media ($below-tablet) {
        width: 100%;
    }
}

.carousel {
    display: inline-block;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: calc(43% - var(--spacer-24));
    -ms-overflow-style: none;
    scrollbar-width: none;
    vertical-align: top;

    &::-webkit-scrollbar {
        display: none;
    }

    @media ($below-tablet) {
        position: relative;
        width: 100%;
        margin-top: var(--spacer-24);
    }
}

.ul {
    height: 100%;
    display: flex;
    align-items: stretch;
}

.listItem {
    --slides-visible: var(--slides-visible-desktop);
    --gutters: calc(var(--slides-visible) - 1);
    --gutter-width: var(--spacer-24);
    --gutter-space: calc(var(--gutter-width) * var(--gutters));
    --width: calc((100% - var(--gutter-space)) / var(--slides-visible));

    flex-shrink: 0;
    width: var(--width);
    margin-right: var(--gutter-width);
    opacity: 1;
    overflow-y: hidden;
    vertical-align: top;
    scale: 1;
    transition:
        scale 0.2s,
        opacity 0.2s;

    &:not([inert]) + *[inert] {
        @media ($above-tablet) {
            opacity: 0.6;

            .pullQuoteSlide {
                scale: 0.6;
            }
        }
    }

    &.singleListItem,
    &:last-child {
        margin-right: 0;
    }

    @media ($below-tablet) {
        --slides-visible: var(--slides-visible-mobile);
    }
}

.carouselNav {
    position: absolute;
    top: 0;
    right: var(--labui-container-margin);
    translate: 0 calc(-100% - var(--header-to-slides-margin));
    gap: var(--spacer-24);

    & button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: var(--spacer-32);
        height: var(--spacer-32);
        box-shadow: inset 0 0 0 1px var(--color-contrast);

        svg {
            width: var(--spacer-16);
            height: var(--spacer-16);
        }
    }

    @media ($below-mobile) {
        display: none;
    }
}

.pullQuoteSlide {
    composes: dark from "../../styles/theming.module.css";
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--spacer-24);
    height: 100%;
    margin: 0;
    padding: var(--spacer-32);
    text-align: left;
    text-wrap: wrap;
    z-index: 0;
    background: var(--xcient-gradient);
    transform-origin: top left;
    transition: scale 0.2s;
    scale: 1;

    @media ($below-laptop) {
        padding: var(--spacer-24);
    }
}

.quote {
    margin: 0;
    font: var(--font-h-32);

    @media ($below-laptop) and ($above-tablet) {
        font-size: 28px;
    }
}

.citation {
    & p {
        font-weight: 500;

        + p {
            opacity: 0.6;
        }
    }
}

.dots {
    margin-top: var(--spacer-24);

    @media ($above-tablet) {
        display: none;
    }
}
